/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2023. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';
import { InvoiceItemCustomization, Invoice, InvoiceItemCustomizationMultiAction } from '@core/models';

export const loadInvoiceItemCustomization = createAction(
  '[ClientDetails:Customizations] Load Invoice Item Customization',
  props<{ clientId: number }>()
);
export const loadInvoiceItemCustomizationSuccess = createAction(
  '[ClientDetails:Customizations] Load Invoice Item Customization Success',
  props<{ items: InvoiceItemCustomization[] }>()
);
export const failure = createAction('[ClientDetails:Customizations] Failure', props<{ errorMessage: string }>());

export const openDialog = createAction(
  '[ClientDetails:Customizations] Open Dialog',
  props<{ item: Partial<InvoiceItemCustomization> }>()
);

export const createItem = createAction(
  '[ClientDetails:Customizations] Create Item',
  props<{ item: InvoiceItemCustomization }>()
);
export const createItemSuccess = createAction(
  '[ClientDetails:Customizations] Create Item Customization',
  props<{ item: InvoiceItemCustomization }>()
);

export const updateItem = createAction(
  '[ClientDetails:Customizations] Update Item',
  props<{ item: Partial<InvoiceItemCustomization> }>()
);
export const updateItemSuccess = createAction(
  '[ClientDetails:Customizations] Update Item Success',
  props<{ item: InvoiceItemCustomization }>()
);

export const duplicateItem = createAction(
  '[ClientDetails:Customizations] Duplicate Item',
  props<{ item: Partial<InvoiceItemCustomization> }>()
);
export const duplicateItemSuccess = createAction(
  '[ClientDetails:Customizations] Duplicate Item Success',
  props<{ item: InvoiceItemCustomization }>()
);

export const deleteItem = createAction('[ClientDetails:Customizations] Delete Item', props<{ id: number }>());
export const deleteItemSuccess = createAction(
  '[ClientDetails:Customizations] Delete Item Success',
  props<{ id: number; deletedInvoiceId: number }>()
);

export const exportToExcel = createAction(
  '[ClientDetails:Customizations] Export to Exel',
  props<{ items: InvoiceItemCustomization[] }>()
);

export const createInvoice = createAction(
  '[ClientDetails:Customizations] Create Invoice',
  props<{ item: InvoiceItemCustomization }>()
);
export const createInvoiceSuccess = createAction(
  '[ClientDetails:Customizations] Create Invoice Success',
  props<{ invoice: Invoice }>()
);

export const removeItemFromInvoice = createAction(
  '[ClientDetails:Customizations] Remove Item From Invoice',
  props<{ item: InvoiceItemCustomization }>()
);
export const removeItemFromInvoiceSuccess = createAction(
  '[ClientDetails:Customizations] Remove Item From Invoice Success',
  props<{ item: InvoiceItemCustomization; deletedInvoiceId: number | null }>()
);

export const moveItemToInvoice = createAction(
  '[ClientDetails:Customizations] Move Item To Invoice',
  props<{ item: InvoiceItemCustomization; invoice: Invoice }>()
);
export const moveItemToInvoiceSuccess = createAction(
  '[ClientDetails:Customizations] Move Item To Invoice Success',
  props<{ item: InvoiceItemCustomization; deletedInvoiceId: number | null }>()
);

export const addItemToInvoice = createAction(
  '[ClientDetails:Customizations] Add Item To Invoice',
  props<{ item: InvoiceItemCustomization; invoice: Invoice }>()
);
export const addItemToInvoiceSuccess = createAction(
  '[ClientDetails:Customizations] Add Item To Invoice Success',
  props<{ item: InvoiceItemCustomization }>()
);

export const multiActon = createAction(
  '[ClientDetails:Customizations] Multi Action',
  props<{ payload: InvoiceItemCustomizationMultiAction }>()
);
export const multiActonSuccess = createAction(
  '[ClientDetails:Customizations]  Multi Action Success',
  props<{ items: InvoiceItemCustomization[]; deletedInvoices: number[]; createdInvoice: Invoice }>()
);
